import { inject } from 'vue';
import type { OverlayManager } from '../overlayService/OverlayManager';

export function useOverlay() {
  const overlay = inject<OverlayManager>('overlay');
  if (!overlay) throw new Error('OverlayManager not provided');
  return overlay;
}
